import { closeModal } from "./closeModal";

export const handleKeyDown = (event, modal) => {
  document.documentElement.removeAttribute("data-mousedown");
  if (event.key === "Escape") {
    event.preventDefault();
    closeModal(modal);
  }
};
